import React from "react";
import Tooltip from "../tooltip/tooltip.tsx";
import "./radioGroup.css";

interface RadioGroupProps {
    options: string[];
    name: string;
    value: string;
    onChange: (value: string) => void;
    title?: string;
    disabledOptions?: string[];
    enabledOption?: string; // if set, only this option is enabled
    tooltipTitle?: string;
    tooltipContent?: string;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
    options,
    name,
    value,
    onChange,
    title,
    disabledOptions,
    enabledOption,
    tooltipTitle,
    tooltipContent,
}) => {
    const isDisabled = (option: string) => {
        if (enabledOption !== undefined) return option !== enabledOption;
        if (disabledOptions !== undefined) return disabledOptions.includes(option);
        return false;
    };

    return (
        <div className="radio-group-container">
            {title && (
                <div className="radio-group-title-row">
                    <div className="radio-group-title">{title}</div>
                    {tooltipTitle && tooltipContent && (
                        <Tooltip title={tooltipTitle} content={tooltipContent} offsetY={-3} />
                    )}
                </div>
            )}
            <div className="radio-group">
                {options.map((option) => {
                    const disabled = isDisabled(option);
                    return (
                        <label key={option} className={`radio-label ${disabled ? "radio-label-disabled" : ""}`}>
                            <input
                                type="radio"
                                name={name}
                                value={option}
                                checked={value === option}
                                onChange={(e) => !disabled && onChange(e.target.value)}
                                className="radio-input"
                                disabled={disabled}
                            />
                            <span className="radio-custom"></span>
                            <span className="radio-text">{option}</span>
                        </label>
                    );
                })}
            </div>
        </div>
    );
};

export default RadioGroup;
